import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import OctopusImage from './OctopusImage'

const Octopus = () => (
  <SectionBase variant="noCopy">
    <Section.Contents>
      <OctopusImage />
    </Section.Contents>
  </SectionBase>
)

export default Octopus
